import {Injectable} from '@angular/core';
import {AnyAdapter} from '@drl/core/api/adapters/any-adapter.service';
import {ApiService} from '@drl/core/api/api.service';
import {GetPatientAppointmentsCommand} from '@drl/shared/commands';
import {Appointments} from '@drl/shared/models';
import {HttpParams} from '@angular/common/http';
import {AppointmentType} from '@drl/shared/utility/appointment-type.enum';
import {AppointmentsAdapter} from '@drl/shared/adapters/appointments-adapter.service';
const sortOrderDesc = 'createdOn DESC';

@Injectable({
  providedIn: 'root',
})
export class PatientAppointmentsService {
  constructor(
    private readonly apiService: ApiService,
    private readonly anyAdapter: AnyAdapter,
    private readonly appointmentAdapter: AppointmentsAdapter,
  ) {}

  getPatientAppointments(
    id: number,
    where?: {
      startDate?: Date;
      endDate?: Date;
      apptType?: AppointmentType;
    },
  ) {
    const command: GetPatientAppointmentsCommand<Appointments> = new GetPatientAppointmentsCommand(
      this.apiService,
      this.appointmentAdapter,
      id,
    );
    const order = [];
    const queryData = {
      and: [],
    };
    if (where) {
      if (where.startDate) {
        queryData.and.push({
          apptDate: {
            gte: where.startDate,
          },
        });
      }
      if (where.endDate) {
        queryData.and.push({
          apptDate: {
            lte: where.endDate,
          },
        });
      }
      if (where.apptType) {
        queryData.and.push({
          apptType: where.apptType,
        });
      }
    }
    const queryStr = JSON.stringify({
      where: queryData,
      order,
    });
    command.parameters = {
      query: new HttpParams().set('filter', queryStr),
    };
    return command.execute();
  }
  getLastAppointmentDetails(
    id: number,
    limit?: number,
    where?: {
      patientId?: number;
    },
  ) {
    const order = [sortOrderDesc];
    const command: GetPatientAppointmentsCommand<Appointments> = new GetPatientAppointmentsCommand(
      this.apiService,
      this.appointmentAdapter,
      id,
    );
    const queryData = {
      patientId: where.patientId,
    };
    const queryStr = JSON.stringify({
      where: queryData,
      order,
      limit,
    });
    let params = new HttpParams();
    params = params.set('filter', queryStr);
    command.parameters = {
      query: params,
    };
    return command.execute();
  }
}
